import React, { useState, useEffect } from "react";
import { Layout, Typography } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CloseOutlined, ReloadOutlined } from "@ant-design/icons";
import { resetStore } from "./redux/actions/resetStoreAction";

const { Header } = Layout;
const { Title } = Typography;

const Navbar = () => {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);

  const translations = {
    English: "IT Happiness Survey",
    Japanese: "ITハピネス調査",
  };
  const surveyTitle = translations[selectedLanguage] || translations.English;

  // Determine if the device is mobile (width < 768px)
  // testing for deployment
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Layout>
      <Header style={isMobile ? mobileStyles.header : styles.header}>
        <Link to="/itux-happiness-survey">
          <div style={isMobile ? mobileStyles.iconContainerLeft : styles.iconContainer}>
            <ReloadOutlined style={styles.iconRight} onClick={() => dispatch(resetStore(true))} />
          </div>
        </Link>
        <Title level={3} style={isMobile ? mobileStyles.title : styles.title}>
          {surveyTitle}
        </Title>
        <Link to="/itux-happiness-survey">
          <div style={isMobile ? mobileStyles.iconContainerRight : styles.iconContainer}>
            <CloseOutlined style={styles.iconLeft} onClick={() => dispatch(resetStore(true))} />
          </div>
        </Link>
      </Header>
    </Layout>
  );
};

const styles = {
  header: {
    display: "flex",
    height: "4vh",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "white",
    padding: "20px 20px",
  },
  title: {
    color: "black",
    fontSize: "16px",
    margin: 0,
    // marginLeft: "22rem",
    // alignItems: "center",
    // justifyContent: "center",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "23px",
    height: "23px",
    borderRadius: "50%",
    border: "1.5px solid rgba(128, 128, 128,0.5)",
    backgroundColor: "white",
  },
  iconLeft: {
    fontSize: "13px",
    color: "black",
  },
  iconRight: {
    fontSize: "13px",
    color: "black",
  },
};

const mobileStyles = {
  header: {
    display: "flex",
    height: "4vh",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
    padding: "20px 20px",
    position: "relative",
  },
  title: {
    color: "black",
    fontSize: "16px",
    margin: 0,
    textAlign: "center",
  },
  iconContainerLeft: {
    position: "absolute",
    left: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "23px",
    height: "23px",
    borderRadius: "50%",
    border: "1.5px solid rgba(128, 128, 128,0.5)",
    backgroundColor: "white",
  },
  iconContainerRight: {
    position: "absolute",
    right: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "23px",
    height: "23px",
    borderRadius: "50%",
    border: "1.5px solid rgba(128, 128, 128,0.5)",
    backgroundColor: "white",
  },
};


export default Navbar;
